import { render } from "./dotLoader.vue?vue&type=template&id=5f8f36b4&scoped=true"
import script from "./dotLoader.vue?vue&type=script&lang=js"
export * from "./dotLoader.vue?vue&type=script&lang=js"

import "./dotLoader.vue?vue&type=style&index=0&id=5f8f36b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8f36b4"]])

export default __exports__